import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'EcommOptionsList',
})(({ spacing }) => ({
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,

    '& > li': { padding: `calc(${spacing(1)} / 2) 0`, cursor: 'pointer' },
    '& > :first-child': { paddingTop: `0` },
    '& > :last-child': { paddingBottom: `0` },
  },
}));

export default useStyles;
